{
  "key": "kerbside-backyard",
  "title": "Kerbside backyard",
  "suburb": "Kerbside",
  "locationGroup": "backyards",
  "grassType": "kikuyu",
  "cellM": 0.5,
  "w": 26,
  "h": 36,
  "rows": [
    "......................ppp.",
    "egppppppppppppggggggggpppe",
    "egppppppppppppggggggggpppe",
    "egppppppppppppggggggggpppe",
    "egppppppppppppggggggggpppe",
    "egppppppppppppggggggggpppe",
    "eggggggggggggggoggggggpppe",
    "ebbgggggggggggggggggggpppe",
    "ebbbggggggggggggggggggpppe",
    "ebbbggggggggggggggggggpppe",
    "ebbbggggggggggggggggggggge",
    "ebbbggggggggggggggggggggge",
    "ebbgggggggggggggggggggggge",
    "ebbgggggggggggggggbbbbbbbe",
    "eoooobbbggggggggggbbbbbbbe",
    "eoooobbbggggggggggbbbbbbbe",
    "eoooobbbggggggggggbbbbbbbe",
    "eoooobbbggggggggggbbbbbbbe",
    "ebbbbgggggggggggggbbbbbbbe",
    "ebbbbgggggggogggggbbbbbbbe",
    "egggggggggggggggggbbbbbbbe",
    "egggggggggggggggggggggggge",
    "egggggggggggggggggggggggge",
    "egggggggggggggggggggggggge",
    "egggggggggggggggggggggggge",
    "egggggggggggggggggooogggge",
    "eggggggggggggggggoooooggge",
    "epppppggggggggggooooooogge",
    "epppppggggggggggooooooogge",
    "eoooooggggggggggooooooogge",
    "eooooogggggggggggoooooggge",
    "eoooooggggggggggggooogggge",
    "eoooooggggggggggggggggggge",
    "eoooooggggggggggggggggggge",
    "eooooogggbbbbbbbbgggggggge",
    "eeeeeeeeeeeeeeeeeeeeeeeeee"
  ],
  "zones": [
  ],
  "rangeMm": [40,60],
  "startLengthMm": [90,140],
  "props": [
    {"id":"colorbond-fence-1","kind":"colorbond-fence","x":0.25,"y":9,"w":0.1,"h":17.5,"solid":false},
    {"id":"colorbond-fence-2","kind":"colorbond-fence","x":12.75,"y":9,"w":0.1,"h":17.5,"solid":false},
    {"id":"colorbond-fence-3","kind":"colorbond-fence","x":6.5,"y":17.75,"w":13,"h":0.1,"solid":false},
    {"id":"shed-1","kind":"shed","x":1.5,"y":16,"w":2.5,"h":3,"solid":true},
    {"id":"veggie-bed-1","kind":"veggie-bed","x":11.5,"y":8.5,"w":2,"h":4,"solid":true},
    {"id":"hills-hoist-1","kind":"hills-hoist","x":6.25,"y":9.75,"r":0.2,"solid":true,"canopyR":2.4},
    {"id":"trampoline-1","kind":"trampoline","x":9.75,"y":14.25,"r":1.6,"solid":true},
    {"id":"cubby-1","kind":"cubby","x":1.5,"y":8,"w":1.5,"h":1.5,"solid":true},
    {"id":"dog-bowl-1","kind":"dog-bowl","x":7.75,"y":3.25,"r":0.15,"solid":true},
    {"id":"tap-1","kind":"tap","x":1.25,"y":0.4,"r":0.1,"solid":false},
    {"id":"garden-hose-1","kind":"garden-hose","x":3.5,"y":4.5,"w":3,"h":0.08,"rot":0.3,"solid":false},
    {"id":"stone-edging-1","kind":"stone-edging","x":10.4,"y":8.5,"w":0.15,"h":4,"solid":false},
    {"id":"brick-edging-1","kind":"brick-edging","x":6.5,"y":16.9,"w":4,"h":0.15,"solid":false}
  ],
  "spawn": {"x":11.75,"y":0.75,"heading":1.5707963267948966},
  "utePark": {"x":11.75,"y":0.25,"heading":1.5707963267948966},
  "weedFraction": 0.15,
  "leaves": {"count":[120,200]},
  "camera": {"fit":"contain","allowLandscape":false},
  "mutations": ["veggie-bed","above-ground-pool","trampoline","magpie-season","sprinkler","bindii","heavy-leaves","lost-ball","hot-day"],
  "slope": {"x":0,"y":0.1}
}
